// my_drive 列表「類型」中文化（Sprint 4-post-c）。
// 常見 mime → 中文；category prefix fallback（圖片/影片/音訊/文字/字型）；未知 → raw（dev debug clue）。

const MIME_LABELS: Record<string, string> = {
  // Office (OOXML)
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel 試算表',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word 文件',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint 簡報',
  'application/msword': 'Word 文件（舊版）',
  'application/vnd.ms-excel': 'Excel 試算表（舊版）',
  'application/vnd.ms-powerpoint': 'PowerPoint 簡報（舊版）',
  // OpenDocument
  'application/vnd.oasis.opendocument.spreadsheet': 'ODF 試算表',
  'application/vnd.oasis.opendocument.text': 'ODF 文件',
  'application/vnd.oasis.opendocument.presentation': 'ODF 簡報',
  // 常見
  'application/pdf': 'PDF 文件',
  'application/json': 'JSON',
  'application/xml': 'XML',
  'application/zip': 'ZIP 壓縮檔',
  'application/x-7z-compressed': '7-Zip 壓縮檔',
  'application/x-rar-compressed': 'RAR 壓縮檔',
  'application/gzip': 'GZip 壓縮檔',
  'application/octet-stream': '二進位檔',
  'text/plain': '純文字',
  'text/csv': 'CSV',
  'text/html': 'HTML',
  'text/markdown': 'Markdown',
  // 系統
  'inode/directory': '資料夾',
};

const CATEGORY_PREFIX: Array<[string, string]> = [
  ['image/', '圖片'],
  ['video/', '影片'],
  ['audio/', '音訊'],
  ['text/', '文字'],
  ['font/', '字型'],
];

export const mimeLabel = (mime: string | null | undefined): string => {
  if (!mime) return '未知';
  if (MIME_LABELS[mime]) return MIME_LABELS[mime];
  for (const [prefix, label] of CATEGORY_PREFIX) {
    if (mime.startsWith(prefix)) {
      const subtype = mime.slice(prefix.length).split(';')[0].toUpperCase();
      return subtype ? `${label} (${subtype})` : label;
    }
  }
  return mime;   // 未知 → raw（dev/使用者回報時的線索）
};
